import Hero from '@/components/hero'
import About from '@/components/about'
import WhatWeDo from '@/components/what-we-do'
import OurClients from '@/components/our-clients'
import Works from '@/components/works'
import CreationInnovation from '@/components/creation-innovation'
import SmoothScroll from '@/components/smooth-scroll'
import Cursor from '@/components/cursor'

export default function App() {
  return (
    <main className="min-h-screen w-full" style={{ backgroundColor: '#0b0b12', minHeight: '100vh' }}>
      <Cursor />
      <SmoothScroll />
      <Hero />
      <About avatarUrl="https://donpuppy.my.canva.site/shota-iasashvili/_assets/media/5e897f9f0eb54d0b0e3442d3ed1cb646.jpg" />
      <WhatWeDo />
      <OurClients />
      <Works />
      <CreationInnovation />
    </main>
  )
}